var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar",staticStyle:{"width":"1.2rem","height":"1.2rem","border-raidus":"0.12rem"},attrs:{"src":_vm.IMGURL}})}
var staticRenderFns = []

export { render, staticRenderFns }